export enum AccountStatus {
  ACTIVE = "Active", // Default — payments up to date and account is active
  SOFT_SUSPENSION = "Soft Suspension", // 0–7 days — usage restricted, Stripe retrying
  DELINQUENT = "Delinquent", // 7–14 days — account locked, dashboard access only
  SUSPENDED = "Suspended", // 14–60 days — service stopped, stop tracking
  TERMINATED = "Terminated", // 60 days — cannot pay, must contact support
  DATA_RETAINED = "Data Retained", // 60–90 days — data kept (read-only) then delete
}
